import { put, call } from 'redux-saga/effects';
import { fetchWithMisToken } from '../../../../utils/fetch-with-mis-token';
import { FETCH_SEARCH_RESULTS, setSearchResults } from '../actions';

/**
 * @typedef {object} FetchSearchResultsAction
 * @property {object} payload
 * @property {string} payload.compseason
 * @property {string} payload.query
 */

/**
 * @param {FetchSearchResultsAction} action - The Redux action.
 */

/**
 *
 * @param action
 */
export function* fetchSearchResults(action) {
    const { compseasonPid, newQuery, posQuery, teamQuery } = action.payload;

    let data = {};

    if (newQuery || posQuery) {
        data = yield call(
            fetchWithMisToken,
            // @ts-ignore
            `${PULSE.app.environment.statsPro}/playersStats/seasons/${compseasonPid}?playerNameLike=${newQuery}&playerPosition=${posQuery}&teamId=${teamQuery}`
        );
    } else {
        data = yield call(
            fetchWithMisToken,
            // @ts-ignore
            `${PULSE.app.environment.cfsApi}/players?pageSize=20&pageNum=1&sortBy=name&seasonId=${compseasonPid}&teamIds=${teamQuery}&playerPosition=${posQuery}`
        );
    }

    yield put(setSearchResults(data));

    yield put(FETCH_SEARCH_RESULTS.success(data));
}
